import { ShieldCheck } from "lucide-react";
import { kycGuidance } from "../lib/kycOps";

/**
 * Turns a raw provider state into the two things staff actually need from it: who the
 * case is waiting on, and what this portal can do about it. The raw strings — `storing`,
 * `unverified` — carry neither meaning on their own.
 */
export function StageGuidance({ state }: { state: string }) {
  const info = kycGuidance(state);
  return <div className={`stage-guidance guidance-${info.tone}`}>
    <span><ShieldCheck size={20} aria-hidden="true" /></span>
    <div>
      <small>{info.label} · waiting on {info.waitingOn.toLowerCase()}</small>
      <strong>{info.summary}</strong>
      <p>{info.action}</p>
    </div>
  </div>;
}
